export function findUnitIndex(guid, units) {
  return units.findIndex(({ unit_guid }) => unit_guid === guid)
}

export function findLessonIndex(guid, lessons) {
  return lessons.findIndex(({ lesson_guid }) => lesson_guid === guid)
}
